import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-delivery-note',
  templateUrl: './document.component.html',
  imports: [CentToEurDisplayDirective, DatePipe]
})
export class DeliveryNoteTemplateComponent implements OnInit {

  public document: any = {}
  public client: any = {}
  public documentLines: any[] = []
  public tax: any = null
  public pay_method: any = null
  id: string | null = null
  type: string | null = null

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  @ViewChild('invoice')
  content!: ElementRef;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.type = this.route.snapshot.paramMap.get('type');
    this.getData(this.id);
  }

  getDocumentLabel(type: string): string {
    const labels: Record<string, string> = {
      'factura': 'Nº Factura',
      'albaran': 'Nº Albarán',
      'presupuesto': 'Nº Presupuesto'
    };
    return labels[type] ?? '';
  }

  // generarPDF() {
  //   const element = document.getElementById('factura');

  //   if (!element) return;

  //   html2canvas(element, { scale: 2 }).then(canvas => {
  //     const imgData = canvas.toDataURL('image/png');

  //     const pdf = new jsPDF('p', 'mm', 'a4');

  //     const imgWidth = 210;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //     pdf.save('factura.pdf');
  //   });
  // }
  getHtml(): string {
    return this.content.nativeElement.innerHTML;
  }

  getData(id: any): any {
    this.apiService.getById(Urls.urls.documents, id).subscribe({
          next: (data: any) => {
            this.document = data.document;
            this.client = data.client;
            this.documentLines = data.document_details;
            this.tax = data.tax;
            this.pay_method = data.pay_method;
            this.cdr.detectChanges();
            if(this.type === 'print') {
            window.print();
            }
          },
          error: (error: any) => {
            console.error('ERROR obtener productos. ' + error);
          },
      });
  }
}
